const currentLocale = require(`./${process.env.GATSBY_LOCALE}.json`);

export default currentLocale;
